let language = {
    STORE_PRODUCT_INACTIVE_PARTNER_DES1: "您的 E-Shop 仍未准备好，请先激活您的 E-Shop，然后稍后再试。",
    STORE_PRODUCT_INACTIVE_PARTNER_DES2: "如果您未收到激活邮件，请前往",
    STORE_PRODUCT_INACTIVE_PARTNER_SETTING: "合作伙伴设置",
    STORE_PRODUCT_INACTIVE_PARTNER_DES3: "，点击",
    STORE_PRODUCT_INACTIVE_PARTNER_DES4: "[激活您的 E-Shop]。",
    STORE_PRODUCT_INACTIVE_PARTNER_DES5: "登录到您的电子邮件，并打开发送自"
};

export { language }
